var Cube = require('cube-js')

var app = function() {

  this.target = $('#header .navbar');
  this.header= $('#header');

  this.init();
  this.top_when_hidding = 140;
  this.last_y = 0;
  this.reached_top = false;
};

Cube.mix(app.prototype, {

  direction: -1,
  last_y: 0,
  window_top_when_hidding: 0,
  header: null,
  reached_top: false,
  quick_hide: false,
  //
  // init: function() {
  //   var me = this;
  //
  //   this.quick_hide = $('body').hasClass('quick_hide');
  //
  //   $(window).on("scroll", function() {
  //     me.onScroll();
  //     me.updateHeader();
  //   });
  //   $(window).on("resize", function() {
  //     me.onResize();
  //   });
  //   me.onResize();
  //   me.updateHeader();
  //
  //   $('.home-dropdown-menu').on('hidden.bs.collapse', function () {
  //     me.header.addClass('menu-collapsed').removeClass('menu-open');
  //   })
  //   $('.home-dropdown-menu').on('show.bs.collapse', function () {
  //     me.header.removeClass('menu-collapsed').addClass('menu-open');
  //   })
  //   cube.on('header:hide', cube.bind(this.hide, this));
  //   cube.on('header:recover', cube.bind(this.recover, this));
  // },

  updateHeader: function () {
    if (this.window_width >= 768) {
      this.header.removeClass('reached_top');
      return;
    }
    var value = this.top_when_hidding + 40;
    if ($(window).scrollTop() > value ) {
      this.header.removeClass('reached_top');
      this.reached_top = false;
    } else {
        this.header.addClass("reached_top");
      if (!this.reached_top && $(window).scrollTop() < value ) {
        this.reached_top = true;
      }
    }
  },

  onResize: function() {
    this.window_width = $(window).width();
  },

  hide: function() {
    this._moveHeader(1);
  },

  recover: function() {
    this._moveHeader(0);
  },

  onScroll: function(detal) {

    if (this.window_width >= 768 || !this.quick_hide) {
      return;
    }
    var scrool_top = $(window).scrollTop();
    var scrool_bottom = scrool_top + this.window_top_when_hidding;

    var detal = scrool_top - this.last_y;
    if (Math.abs(detal) <= 10) {
      return;
    }
    this.last_y = scrool_top;

    var direction = 0;
    if (detal > 0) {
      this.hide();
    } else {
      this.recover();
    }
  },

  _moveHeader: function(direction) {
    if (direction == this.direction) {
      return;
    }

    this.direction = direction;
    this.target.stop();
    if (direction == 1) {
      this.target.animate({'top': -this.top_when_hidding});
    } else {
      this.target.animate({'top': 0});
    }
  },
});

module.exports = app;



//////////////////
// WEBPACK FOOTER
// ./src/js/header.js
// module id = 46
// module chunks = 1